/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAppAccessCodeDto } from '../models/work-app-access-code-dto';
import { WorkCategoryNameEnum } from '../models/work-category-name-enum';
import { WorkContact } from '../models/work-contact';
import { WorkContactArchivePreviewDto } from '../models/work-contact-archive-preview-dto';
import { WorkContactArchiveResultDto } from '../models/work-contact-archive-result-dto';
import { WorkContactDuplicateDto } from '../models/work-contact-duplicate-dto';
import { WorkContactStatisticsDto } from '../models/work-contact-statistics-dto';
import { WorkCreateContactDto } from '../models/work-create-contact-dto';
import { WorkCreateLeadFromReservationdDto } from '../models/work-create-lead-from-reservationd-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkEncryptedIdDto } from '../models/work-encrypted-id-dto';
import { WorkFindContactDuplicatesDto } from '../models/work-find-contact-duplicates-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkTransformToLeadDto } from '../models/work-transform-to-lead-dto';
import { WorkUpdateContactDto } from '../models/work-update-contact-dto';

@Injectable({ providedIn: 'root' })
export class WorkContactsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactsV2ControllerFindAllPaginated()` */
  static readonly ContactsV2ControllerFindAllPaginatedPath = '/v2/contacts';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerFindAllPaginated$Response(
    params?: {
      withMailPhones?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by categoryId query param.
     *           <p>
     *              <b>Format: </b> filter.categoryId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.categoryId=$not:$like:John Doe&filter.categoryId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.categoryId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by firstName query param.
     *           <p>
     *              <b>Format: </b> filter.firstName={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.firstName=$not:$like:John Doe&filter.firstName=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$contains</li>
     * <li>$ilike</li></ul>
     */
      'filter.firstName'?: Array<string>;

    /**
     * Filter by lastName query param.
     *           <p>
     *              <b>Format: </b> filter.lastName={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.lastName=$not:$like:John Doe&filter.lastName=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$contains</li>
     * <li>$ilike</li></ul>
     */
      'filter.lastName'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>company</li>
     * <li>firstName</li>
     * <li>lastName</li>
     * <li>street</li>
     * <li>zipcode</li>
     * <li>city</li>
     * <li>category.name</li>
     * <li>created</li></ul>
     */
      sortBy?: Array<'company:ASC' | 'company:DESC' | 'firstName:ASC' | 'firstName:DESC' | 'lastName:ASC' | 'lastName:DESC' | 'street:ASC' | 'street:DESC' | 'zipcode:ASC' | 'zipcode:DESC' | 'city:ASC' | 'city:DESC' | 'category.name:ASC' | 'category.name:DESC' | 'created:ASC' | 'created:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> company,firstName,lastName,street,zipcode
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>company</li>
     * <li>firstName</li>
     * <li>lastName</li>
     * <li>street</li>
     * <li>zipcode</li>
     * <li>city</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'categoryId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'firstName'?: (string | Array<string>);
'lastName'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('withMailPhones', params.withMailPhones, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.businessunitId', params['filter.businessunitId'], {});
      rb.query('filter.categoryId', params['filter.categoryId'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.firstName', params['filter.firstName'], {});
      rb.query('filter.lastName', params['filter.lastName'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkContact>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'businessunitId'?: (string | Array<string>);
        'categoryId'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        'firstName'?: (string | Array<string>);
        'lastName'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerFindAllPaginated(
    params?: {
      withMailPhones?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by categoryId query param.
     *           <p>
     *              <b>Format: </b> filter.categoryId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.categoryId=$not:$like:John Doe&filter.categoryId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.categoryId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by firstName query param.
     *           <p>
     *              <b>Format: </b> filter.firstName={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.firstName=$not:$like:John Doe&filter.firstName=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$contains</li>
     * <li>$ilike</li></ul>
     */
      'filter.firstName'?: Array<string>;

    /**
     * Filter by lastName query param.
     *           <p>
     *              <b>Format: </b> filter.lastName={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.lastName=$not:$like:John Doe&filter.lastName=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$contains</li>
     * <li>$ilike</li></ul>
     */
      'filter.lastName'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>company</li>
     * <li>firstName</li>
     * <li>lastName</li>
     * <li>street</li>
     * <li>zipcode</li>
     * <li>city</li>
     * <li>category.name</li>
     * <li>created</li></ul>
     */
      sortBy?: Array<'company:ASC' | 'company:DESC' | 'firstName:ASC' | 'firstName:DESC' | 'lastName:ASC' | 'lastName:DESC' | 'street:ASC' | 'street:DESC' | 'zipcode:ASC' | 'zipcode:DESC' | 'city:ASC' | 'city:DESC' | 'category.name:ASC' | 'category.name:DESC' | 'created:ASC' | 'created:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> company,firstName,lastName,street,zipcode
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>company</li>
     * <li>firstName</li>
     * <li>lastName</li>
     * <li>street</li>
     * <li>zipcode</li>
     * <li>city</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'categoryId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'firstName'?: (string | Array<string>);
'lastName'?: (string | Array<string>);
};
};
}> {
    return this.contactsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'categoryId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'firstName'?: (string | Array<string>);
'lastName'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'categoryId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'firstName'?: (string | Array<string>);
'lastName'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerCreate()` */
  static readonly ContactsV2ControllerCreatePath = '/v2/contacts';

  /**
   * Required permissions: contacts:create, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerCreate$Response(
    params: {
      body: WorkCreateContactDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContact>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContact>;
      })
    );
  }

  /**
   * Required permissions: contacts:create, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerCreate(
    params: {
      body: WorkCreateContactDto
    },
    context?: HttpContext
  ): Observable<WorkContact> {
    return this.contactsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContact>): WorkContact => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerGetContactsDropdownOptions()` */
  static readonly ContactsV2ControllerGetContactsDropdownOptionsPath = '/v2/contacts/contactsDropdownOptions/{contactType}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerGetContactsDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerGetContactsDropdownOptions$Response(
    params: {
      contactType: WorkCategoryNameEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerGetContactsDropdownOptionsPath, 'get');
    if (params) {
      rb.path('contactType', params.contactType, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerGetContactsDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerGetContactsDropdownOptions(
    params: {
      contactType: WorkCategoryNameEnum;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.contactsV2ControllerGetContactsDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerGetStatistics()` */
  static readonly ContactsV2ControllerGetStatisticsPath = '/v2/contacts/statistics';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerGetStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerGetStatistics$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContactStatisticsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerGetStatisticsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContactStatisticsDto>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerGetStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerGetStatistics(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkContactStatisticsDto> {
    return this.contactsV2ControllerGetStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContactStatisticsDto>): WorkContactStatisticsDto => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerFindOneById()` */
  static readonly ContactsV2ControllerFindOneByIdPath = '/v2/contacts/{id}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContact>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContact>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkContact> {
    return this.contactsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContact>): WorkContact => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerUpdate()` */
  static readonly ContactsV2ControllerUpdatePath = '/v2/contacts/{id}';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateContactDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateContactDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.contactsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerFindRelatedContactsForContact()` */
  static readonly ContactsV2ControllerFindRelatedContactsForContactPath = '/v2/contacts/{id}/relatedContacts';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerFindRelatedContactsForContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerFindRelatedContactsForContact$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkContact>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerFindRelatedContactsForContactPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkContact>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerFindRelatedContactsForContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerFindRelatedContactsForContact(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkContact>> {
    return this.contactsV2ControllerFindRelatedContactsForContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkContact>>): Array<WorkContact> => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerGetEncryptedId()` */
  static readonly ContactsV2ControllerGetEncryptedIdPath = '/v2/contacts/{id}/encryptedId';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerGetEncryptedId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerGetEncryptedId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEncryptedIdDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerGetEncryptedIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEncryptedIdDto>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerGetEncryptedId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerGetEncryptedId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEncryptedIdDto> {
    return this.contactsV2ControllerGetEncryptedId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEncryptedIdDto>): WorkEncryptedIdDto => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerFindDuplicates()` */
  static readonly ContactsV2ControllerFindDuplicatesPath = '/v2/contacts/findDuplicates';

  /**
   * Required permissions: contacts:create, contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerFindDuplicates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerFindDuplicates$Response(
    params: {
      body: WorkFindContactDuplicatesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkContactDuplicateDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerFindDuplicatesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkContactDuplicateDto>>;
      })
    );
  }

  /**
   * Required permissions: contacts:create, contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerFindDuplicates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerFindDuplicates(
    params: {
      body: WorkFindContactDuplicatesDto
    },
    context?: HttpContext
  ): Observable<Array<WorkContactDuplicateDto>> {
    return this.contactsV2ControllerFindDuplicates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkContactDuplicateDto>>): Array<WorkContactDuplicateDto> => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerCreateLeadFromReservation()` */
  static readonly ContactsV2ControllerCreateLeadFromReservationPath = '/v2/contacts/createLeadFromReservation';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerCreateLeadFromReservation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerCreateLeadFromReservation$Response(
    params: {
      body: WorkCreateLeadFromReservationdDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerCreateLeadFromReservationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerCreateLeadFromReservation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerCreateLeadFromReservation(
    params: {
      body: WorkCreateLeadFromReservationdDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.contactsV2ControllerCreateLeadFromReservation$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerGenerateAppAccessCodeForContact()` */
  static readonly ContactsV2ControllerGenerateAppAccessCodeForContactPath = '/v2/contacts/{id}/appAccessCode';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerGenerateAppAccessCodeForContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerGenerateAppAccessCodeForContact$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAppAccessCodeDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerGenerateAppAccessCodeForContactPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAppAccessCodeDto>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerGenerateAppAccessCodeForContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerGenerateAppAccessCodeForContact(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkAppAccessCodeDto> {
    return this.contactsV2ControllerGenerateAppAccessCodeForContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAppAccessCodeDto>): WorkAppAccessCodeDto => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerDeleteAppAccessCodeForContact()` */
  static readonly ContactsV2ControllerDeleteAppAccessCodeForContactPath = '/v2/contacts/{id}/appAccessCode';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerDeleteAppAccessCodeForContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerDeleteAppAccessCodeForContact$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerDeleteAppAccessCodeForContactPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerDeleteAppAccessCodeForContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerDeleteAppAccessCodeForContact(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.contactsV2ControllerDeleteAppAccessCodeForContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerTransformToLead()` */
  static readonly ContactsV2ControllerTransformToLeadPath = '/v2/contacts/{id}/transformToLead';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerTransformToLead()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerTransformToLead$Response(
    params: {
      id: number;
      body: WorkTransformToLeadDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContact>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerTransformToLeadPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContact>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerTransformToLead$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsV2ControllerTransformToLead(
    params: {
      id: number;
      body: WorkTransformToLeadDto
    },
    context?: HttpContext
  ): Observable<WorkContact> {
    return this.contactsV2ControllerTransformToLead$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContact>): WorkContact => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerFindArchivePreview()` */
  static readonly ContactsV2ControllerFindArchivePreviewPath = '/v2/contacts/{id}/archivePreview';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerFindArchivePreview()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerFindArchivePreview$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContactArchivePreviewDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerFindArchivePreviewPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContactArchivePreviewDto>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerFindArchivePreview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerFindArchivePreview(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkContactArchivePreviewDto> {
    return this.contactsV2ControllerFindArchivePreview$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContactArchivePreviewDto>): WorkContactArchivePreviewDto => r.body)
    );
  }

  /** Path part for operation `contactsV2ControllerArchiveContactAndProjects()` */
  static readonly ContactsV2ControllerArchiveContactAndProjectsPath = '/v2/contacts/{id}/archiveContactAndProjects';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV2ControllerArchiveContactAndProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerArchiveContactAndProjects$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContactArchiveResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsV2Service.ContactsV2ControllerArchiveContactAndProjectsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContactArchiveResultDto>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV2ControllerArchiveContactAndProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV2ControllerArchiveContactAndProjects(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkContactArchiveResultDto> {
    return this.contactsV2ControllerArchiveContactAndProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContactArchiveResultDto>): WorkContactArchiveResultDto => r.body)
    );
  }

}
